<template>
  <div class="result-view view">
    <div class="result-content-view content-view">
      <div class="rc-header content-header">
        <div class="rc-header-sparkle content-header-sparkle"></div>
        CONGRATULATIONS, YOU'VE COLLECTED A MISFIT!
      </div>
      <div class="rc-copy">Enter here to be eligible for a chance to win exclusive Jolly Rancher prizes.</div>
      <div
        :class="[
          'rc-form-container',
          validForm ? '' : 'invalid-form'
        ]"
      >

        <Input
          :class="'rc-form-field-wrapper'"
          v-model="userData.name.value"
          defaultText="Full Name"
          dataType="text"
          regex="^[a-zA-Z\s]*$"
          :showError="userData.name.error"
          :onInputCB="(errLog) => { validateData('name', errLog) }"
        />

        <Input
          :class="'rc-form-field-wrapper'"
          v-model="userData.email.value"
          defaultText="Email"
          dataType="email"
          :customFilter="validateEmail"
          :showError="userData.email.error"
          :onInputCB="(errLog) => { validateData('email', errLog) }"
        />

        <Input
          :class="'rc-form-field-wrapper'"
          v-model="userData.phone.value"
          defaultText="Phone Numbers"
          dataType="tel"
          :customFilter="validatePhone"
          :showError="userData.phone.error"
          :onInputCB="(errLog) => { validateData('phone', errLog) }"
        />

        <Input
          :class="'rc-form-field-wrapper'"
          v-model="userData.address.value"
          defaultText="Address"
          dataType="text"
          regex="^[a-zA-Z0-9\s\-\.\#\'\()]*$"
          :showError="userData.address.error"
          :onInputCB="(err) => { validateData('address', err) }"

        />

        <Input
          :class="'rc-form-field-wrapper'"
          v-model="userData.city.value"
          defaultText="City"
          dataType="text"
          regex="^[a-zA-Z0-9\s\-\.]*$"
          :showError="userData.city.error"
          :onInputCB="(err) => { validateData('city', err) }"
        />

        <div class="rc-form-container-grid">
          <Input
            :class="'rc-form-field-wrapper small'"
            v-model="userData.province.value"
            defaultText="Province"
            dataType="select"
            :selectOptions="provinces"
            :showError="userData.province.error"
            :onInputCB="(err) => { validateData('province', err) }"
          />

          <Input
            :class="'rc-form-field-wrapper small'"
            v-model="userData.postalCode.value"
            defaultText="Postal Code"
            dataType="text"
            regex="^([a-zA-Z0-9]{3}( ?)[a-zA-Z0-9]{3})$"
            :showError="userData.postalCode.error"
            :onInputCB="(err) => { validateData('postalCode', err) }"
          />
          <!-- old regex -->
          <!-- regex="^[a-zA-Z0-9\s\-\.]*$" -->

        </div>

        <div class="rc-form-container-grid checkbox">
          <Input
            :class="'rc-form-field-wrapper checkbox'"
            v-model="userData.legalAge.value"
            dataType="checkbox"
            :showError="userData.legalAge.error"
            :onInputCB="(err) => { validateData('legalAge', err) }"
          />
          <div
            :class="[
              'rc-form-checkbox-label',
              userData.legalAge.error ? 'error' : '',
            ]"
          >
            I am at least 13 years old
          </div>
        </div>


      </div>
      <Button
        :class="['rc-submit-btn', validForm ? '' : 'invalid-form']"
        :label="'SUBMIT'"
        @clicked="handleSubmitBtnClicked"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api';

import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';

export default {
  name: 'Result',
  components: {
    Button,
    Input,
  },

  setup(props, context) {
    const {
      $router,
      $store
    } = context.root;

    // Properties
    const totalCorrectMisfits = computed(() => {
      $store.getters['user/getTotalCorrectMisfits'];
    })
    const userData = ref({
      name: {
        value: null,
        error: null,
      },
      email: {
        value: null,
        error: null,
      },
      phone: {
        value: null,
        error: null,
      },
      address: {
        value: null,
        error: null,
      },
      city: {
        value: null,
        error: null,
      },
      province: {
        value: null,
        error: null,
      },
      postalCode: {
        value: null,
        error: null,
      },
      legalAge: {
        value: null,
        error: null
      },
    });
    const provinces = ref(
      [
        {
          id: 'AB',
          value: 'Alberta',
        },
        {
          id: 'BC',
          value: 'British Columbia',
        },
        {
          id: 'MB',
          value: 'Manitoba'
        },
        {
          id: 'NB',
          value: 'New Brunswick'
        },
        {
          id: 'NL',
          value: 'Newfoundland and Labrador'
        },
        {
          id: 'NT',
          value: 'Northwest Territories'
        },
        {
          id: 'NS',
          value: 'Nova Scotia'
        },
        {
          id: 'NU',
          value: 'Nunavut'
        },
        {
          id: 'ON',
          value: 'Ontario'
        },
        {
          id: 'PE',
          value: 'Prince Edward Island'
        },
        {
          id: 'QC',
          value: 'Quebec'
        },
        {
          id: 'SK',
          value: 'Saskatchewan'
        },
        {
          id: 'YT',
          value: 'Yukon'
        },
      ]
    );

    const validForm = ref(false);
    const submitting = ref(false);
    const legalAge = ref(false);

    /**
     * Vue Hooks
     */
    onMounted(() => {

    });

    /**
     * Methods
     */
    const handleSubmitBtnClicked = () => {
      // Submit user info to the backend
      if( submitting.value === true ) {
        return;
      }

      if( validForm.value ) {
        // let data = {
        //   name: 'test onex',
        //   email: 'test1@avatarlabs.com',
        //   phone: '1234567899',
        //   address: 'kslkd llkk',
        //   city: 'lksldl',
        //   province: 'AL',
        //   postalCode: '1K1 L9O',
        //   misfitId: 'mer-bear-orange-pineapple',
        // };

        let data = {
          name: userData.value.name.value,
          email: userData.value.email.value,
          phone: userData.value.phone.value,
          address: userData.value.address.value,
          city: userData.value.city.value,
          province: userData.value.province.value,
          postalCode: userData.value.postalCode.value,
          // misfitId: $store.getters['user/getQuizMisfitId']
          misfitId: $store.state.user.quizMisfitId
        }

        submitting.value = true;

        console.log('validForm, can submit user info');
        console.log(data);

        $store.dispatch('user/submitUserInfo', data, {root:true})
          .then(() => {
            console.log('submitUserInfo done');

            $router.push({path:'/collection'});
          })
          .catch((error) => {
            console.log(error);

            // Note:
            //  What to do when there is an error?
          })
      } else {
        showErrors();
      }

      // // Go to the collection screen when that's done.
      // $router.push({path:'/collection'});
    }

    const showErrors = () => {
      for( let data in userData.value ) {
        if( userData.value[data].error === null ) {
          userData.value[data].error = true;
        }
      }

      // if( userData.value.name.error === null ) {
      //   userData.value.name.error = true;
      // }
    }

    const validateData = (inputKey, dataErr) => {
      // console.log('inputKey:', inputKey);
      // console.log(dataErr);
      let targetVal = userData.value[inputKey];
      targetVal.error = dataErr;

      validateUserData();

    };

    const validateUserData = () => {
      let isValid = true;

      for( let data in userData.value ) {
        let currData = userData.value[data];
        if (
          currData.value == null ||
          currData.error == true
        ) {
          isValid = false;
        }
      }

      validForm.value = isValid;
    };

    const validateEmail = (value) => {
      const _emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


      if (_emailRegex.test(value)) {
        //valid
        console.log('valEmail')
        return false;

      } else {
        //invalid
        console.log('invalEmail')
        return true;

      }

      return true;

    };

    const validatePhone = (value) => {
      // console.log('validatePhone');

      const phoneRegex = /[0-9]/;
      const notDigitRegex = /[^(0-9\-)]/;
      let arr = value.split('');
      let count = 0;

      for( let i=0; i<arr.length; i++ ) {
        if( notDigitRegex.test(arr[i]) ) {
          return true;
        } else if( phoneRegex.test(arr[i]) ) {
          count++;
        }
      }

      // console.log('number of digits:', count);

      // return true;

      if( count >= 10 ) {
        return false;
      }

      return true;
    };

    return {
      // Properties
      totalCorrectMisfits,
      userData,
      provinces,
      validForm,
      submitting,

      // Methods
      handleSubmitBtnClicked,

      validateData,
      validateUserData,
      validateEmail,
      validatePhone,
    }
  },
}

</script>

<style lang="scss" scoped>
$padding-top: 180px;
$mobile-padding-top: 19vh;
$mobile-height-short-padding-top: 15vh;
// $mobile-padding-top: 19vh;
// $mobile-height-short-padding-top: 15vh;

.result-view {
  padding-top: #{$padding-top};
}

.result-content-view {
  // position: relative;
  font-size: 2rem;
  // min-height: calc(var(--vh, 1vh) * 100 - #{$padding-top});
  height: calc(#{$min-height} - #{$padding-top});
}

.rc-header {
  position: relative;
  font-size: 1.1em;
  width: 86%;
  padding-top: 1em;
  margin: 0 auto 0 auto;
  // padding: 1.4em 0.5em 1.4em 0.5em;
  text-align: center;
  letter-spacing: 0.03em;
  @include font-knewave;


}

// .rc-header-sparkle {
//   // position: absolute;
//   // top: 50%;
//   // left: 50%;
//   // width: 100%;
//   // transform: translateX(-52%) translateY(-50%);
//   //
//   // background-image: url('~@/assets/images/header_sparkle.png');
//   // background-size: contain;
//   // background-repeat: no-repeat;
//   //
//   // @include bg-image(923, 282);
// }

.rc-copy {
  position: relative;
  font-size: 0.8em;
  width: 86%;
  margin: 2em auto 0 auto;
  @include font-montserrat;
}

.rc-form-container {
  position: relative;
  width: 88%;
  margin: 1.5em auto 0 auto;
  font-size: 0.5em;

  // &.invalid-form {
  //   .rc-submit-btn {
  //     opacity: 0.6;
  //   }
  // }
}

.rc-form-field-wrapper {
  height: initial;
  background-image: url('~@/assets/images/form_input_bg_large.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  margin-bottom: 1em;

  @include bg-image(949, 123);

  &.small {
    background-image: url('~@/assets/images/form_input_bg_small.png');
    @include bg-image(461, 123);
  }

  &.checkbox {
    width: 2em;
    height: 2em;
    background-image: url('~@/assets/images/form_input_bg_checkbox.png');

    &::v-deep .form-field {
      width: 100%;
    }

    &::v-deep .form-field-check-mark {
      // background-color: #ffff00;
      background-color: transparent;
      background-image: url('~@/assets/images/form_input_checkmark.png');
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
    }


  }

  &::v-deep .form-field {
    color: #ffffff;
    text-align: center;
    font-size: 1.6em;
  }

  &::v-deep .form-field-label {
    color: #ffffff;
    text-align: center;
    font-size: 1.6em;
  }

  &::v-deep select {
    // padding-left: 2.4em;
  }

  &.err {
    &::v-deep .form-field {
      color: #ff0000;
    }

    &::v-deep .form-field-label {
      color: #ff0000;
    }
  }
}

.rc-form-container-grid {
  display: flex;
  justify-content: space-between;

  &.checkbox {
    justify-content: center;
    align-items: center;
  }

  & div {
    width: 49%;
  }

  .rc-form-field-wrapper.checkbox {
    // width: inherit;
    flex-grow: 0;
    margin-left: 0;
    margin-right: 0;
  }

  .rc-form-checkbox-label {
    width: initial;
  }
}

.rc-form-checkbox-label {
  margin-bottom: 1em;
  font-size: 1.2em;
  margin-left: 0.2em;
  text-align: left;
  padding-left: 0.6em;

  &.error {
    color: #ff0000;
  }
}

.rc-submit-btn {
  position: absolute;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);

  &.invalid-form {
    opacity: 0.6;
    cursor: default;
  }
}

@include height-medium {
  .result-content-view {
    font-size: 1.8rem;
  }
}

@include height-short {
  .result-content-view {
    font-size: 1.6rem;
  }
}

@include mobile {
  .result-view {
    padding-top: $mobile-padding-top;
  }

  .result-content-view {
    font-size: 1.6rem;
    padding-top: 0.75em;
    height: initial;
    min-height: calc(var(--vh, 1vh) * 100 - #{$mobile-padding-top});
  }

  .rc-header {
    font-size: 1.0em;
    width: 66%;
    padding-top: 0.5em;
  }

  .rc-copy {
    width: 70%;
    margin-top: 1.75em;
  }

  .rc-form-container {
    width: 74%;

    &::v-deep .form-field {
      // font-size: 1.4em;
    }
  }

  .rc-form-field-wrapper {
    // @include bg-image(1049, 123);
  }
}

@include mobile-small {
  .result-content-view {
    font-size: 1.6rem;
  }

  .rc-form-container {
    width: 74%;

    &::v-deep .form-field {
      // font-size: 1.4em;
    }
  }
}

body.touch {
  @include height-medium {

  }

  @include height-short {
    .result-view {
      padding-top: #{$mobile-height-short-padding-top};
    }

    .result-content-view {
      min-height: calc(var(--vh, 1vh) * 100 - #{$mobile-height-short-padding-top});
    }

    .rc-form-container {
      width: 70%;
    }

    .rc-form-field-wrapper {
      margin-bottom: 0.7em;
    }
  }

  @include mobile-aspect-ratio-40-62 {
    .rc-header {
      font-size: 0.9em;
      width: 58%;
    }

    .rc-form-container {
      width: 68%;
    }
  }

  @include mobile-aspect-ratio-40-59 {
    .result-content-view {
      font-size: 1.5rem;
    }

    .rc-header {
      font-size: 0.9em;
      width: 54%;
    }

    .rc-copy {
      width: 62%;
    }

    .rc-form-container {
      width: 64%;
    }
  }
}

</style>
